import React from 'react';
import classnames from 'classnames';

import { usePromoModel } from '../../contexts/PromoModelProvider';
import { PromoProgressBarSegment } from './subcomponents/PromoProgressBarSegment/PromoProgressBarSegment';
import { PromoProgressAdornment } from './subcomponents/PromoProgressBarAdornment/PromoProgressBarAdornment';
import './PromoProgressBar.scss';

export const PromoProgressBar = () => {
  const { rewardTiers, isBmsm } = usePromoModel();

  const promoProgressSegmentClasses = classnames('promo-progress-segment', {
    'promo-progress-segment--bmsm': isBmsm,
  });

  return (
    <div className="promo-progress-bar">
      {rewardTiers.map((rewardTier) => (
        <span
          className={promoProgressSegmentClasses}
          key={`promo-tier-${rewardTier.tier}`}
        >
          <PromoProgressBarSegment rewardTier={rewardTier} />
          <PromoProgressAdornment rewardTier={rewardTier} />
        </span>
      ))}
    </div>
  );
};

PromoProgressBar.displayName = 'PromoProgressBar';
